@if (isLoading) {
  <div class="loading">
    <div class="loading_txt">
      <div class="load_txt">{{"myorder.loadinglabel" | cxTranslate}}</div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
@if (enablePage?.showukCartReviewSection && reviewPageData) {
  <div class="reviewOrderBody_container" id="OM_reviewOrder">
    <div class="OM_contentHeader pb-3">
      <div class="col-xs-12 col-md-6 no-pad cart_neworderheader margin-B20">
        <span class="amendOrderHeader">{{"ukmyorder.amendtxt" | cxTranslate}}&nbsp;</span><span class="editseason">{{seasonValue | seasonspilt}}</span>@if (prepreseason!=seasonValue) {
        <span class="amendOrderHeader2" >&nbsp;Order</span>
        }@if (prepreseason==seasonValue) {
        <span class="amendOrderHeader2" >&nbsp;Pre-order</span>
      }
    </div>
    <section class="col-xs-12 OM_productDoseSection">
        <!-- <div class="col-xs-12 OM_selectline"></div>
        <div class="clearboth"></div> -->

        <!-- <div class="OM_reviewOrderHeader">Review Amended Order</div>
        <div class="OM_reviewOrderSubHeader">Organisation Name</div> -->


        <!-- <section class="col-xs-12 col-md-12 no-pad costContainerDiv">
            <div class="col-xs-12 col-md-7 no-pad">
                <div class="OM_reviewOrderTableName">Summary</div>
                
                <table id="prodCostTable">
                    <tbody>
                        <tr class="border_bottom">
                            <th class="tablebg">Location&nbsp;</th>
                            <ng-container *ngFor="let product of reviewPageData.productList">
                                <ng-container *ngIf="product.baseName == 'AQIV'">
                                    <th class="tablebg aqivPrice">aTIV Doses
                                        <span>({{product.priceData.formattedValue}} per dose)</span>
                                    </th>
                                </ng-container>
                                <ng-container *ngIf="product.baseName == 'QIVC'">
                                    <th class="tablebg aqivPrice">TIVc Doses
                                        <span>({{product.priceData.formattedValue}} per dose)</span>
                                    </th>
                                </ng-container>
                                
                            </ng-container>
                            <th class="tablebg">Total Cost<div class="reviewPriceDetails">(Excluding VAT)</div>
                            </th>
                        </tr>
                        <ng-container *ngFor="let location of reviewPageData.reviewData.cartEntries">
                            <tr class="border_bottom reviewProdCount" id="prodLocation1">
                                <td class="OM_productLocation reviewPageLoc">{{location.locname}}</td>
                                <ng-container *ngFor="let product of location.products">
                                    <td class="aQIVDose">{{product.qty | number}}</td>
                                </ng-container>
                             
                                <td class="totalLocationDose">£{{location.prodCost}}</td>

                            </tr>

                        </ng-container>
                        <tr>
                            <td class="tablebg totalText">Total</td>
                            <td class="tablebg aqivTotal">{{aqivCost}}</td>
                            <td class="tablebg">
                                
                                <div class="reviewDoseField">
                                    <div class="qivcTotal">{{qivcCost}}</div>
                                    <div class="qivcTotalExtra" style="display: none;"></div>
                                </div>
                            </td>
                            <td class="tablebg finalCost">£{{totalCost}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="col-xs-12 astericText">
                    <div class="astericTextpara1">* Risk-Free Ordering</div>
                    <div class="astericTextpara2">Should new influenza policy guidance be issued that no longer
                        recommends either CSL Seqirus flu vaccines in their respective age group(s), you can cancel that
                        respective part of your order.</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="rightText1">Sales Contact Information</div>
                <div class="rightText2">Communications regarding placing this order will be sent to the following
                    person. For each location, you can indicate the best contact to receive delivery updates below.
                </div>
                <div class="rightText3" *ngIf="reviewPageData.reviewData.salesContact">
                    {{reviewPageData.reviewData.salesContact.name}}<br>{{reviewPageData.reviewData.salesContact.email}}<br>93724868326
                    Ext. 7556</div>
                <div class="rightText4">Order Terms</div>
                <div class="rightText5">Sale or Return</div>
                <div class="rightText6">
                    You will be eligible to return up to <span>
                        {{reviewPageData.priceResponse.SOR | number}}%</span>
                    of your ordered volume, per product</div>
                <div class="rightText7">Credit Days</div>
                <div class="rightText8">
                    Invoices will be issued with <span>
                        {{reviewPageData.priceResponse.creditDays}}</span>
                    credit days</div>
            </div>
        </section> -->
       <!--  <div class="col-xs-12 OM_selectline"></div> -->
        <div class="clearboth"></div>
        <!-- location details starts -->
        <div class="reviewOrder_locContainer">
            <input type="hidden" name="requestType" value="CR">
            <!-- location 1 starts -->
            <div class="locationDiv">
                <div class="locDiv col-xs-12 no-pad" id="prodLocation1"
                    *ngFor="let location of reviewPageData.reviewData?.cartEntries; let i= index">
                    <div id="deliveylocation">
                        <div class="row">
                            <div class="col-xs-12">
                                <div id="deliveryparent">
                                    <div class=" col-xs-12 no-padding" [ngClass]="seasonValue==prepreseason?'prepredelivery':''">
                                            
                                               
                                        <div class="preprebox" [ngClass]="seasonValue==prepreseason?'col-xs-8':'col-xs-12'">
                                            <div [innerHtml]="reviewcontent?.content"></div>
                                            <div class="col-xs-12 inputSection prepredelivery">
                                                <div class="inputParent col-xs-8 no-pad">
                                                    <label class="prelabel">{{"startorderUk.reviewpage.firstname" | cxTranslate}}</label> <input type="text"
                                                    [ngClass]="location.deliveryContact.firstNameErrorMsg ? 'has-error' : ''"
                                                    name="{{i}}" class="dynFirstname col-xs-6 form-control" id=""
                                                    [(ngModel)]="location.deliveryContact.name"  (keyup)="checkForErrrors()"
                                                    (ngModelChange)="handleOnInputValueChange($event,'firstName',i)"
                                                    autocomplete="no">
                                                <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                    *ngIf="location.deliveryContact.firstNameErrorMsg"></span>
                                                <label id="{{i}}" class="error help-block" for="{{i}}"
                                                    *ngIf="location.deliveryContact.firstNameErrorMsg ">{{location.deliveryContact.firstNameErrorMsg}}</label>
                                                 <!-- Please enter only letters -->
                                                    </div>
                                                <div class="inputParent" [ngClass]="location.deliveryContact.emailErrorMsg ? 'has-error' : ''">
                                                    <label class="prelabel">{{"startorderUk.reviewpage.email" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    [(ngModel)]="location.deliveryContact.email"  (keyup)="checkForErrrors()"
                                                    (ngModelChange)="handleOnInputValueChange($event,'email',i)"
                                                    class="dynemail form-control" id="" autocomplete="no">
                                                <span *ngIf="location.deliveryContact.emailErrorMsg"
                                                    class="glyphicon form-control-feedback glyphicon-exclamation-sign" ></span>
                                                <label id="{{i}}" class="error help-block" for="{{i}}"
                                                    *ngIf="location.deliveryContact.emailErrorMsg">{{location.deliveryContact.emailErrorMsg}}</label>
                                                </div>
                                                <div class="">
                                                    <div class="col-xs-6 no-pad inputParent" [ngClass]="location.deliveryContact.phoneNumberErrorMsg ? 'has-error' : ''">
                                                        <label class="prelabel">{{"startorderUk.reviewpage.phnnum" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                                        class="dynphno form-control" id=""
                                                        [(ngModel)]="location.deliveryContact.phone"  (keyup)="checkForErrrors()"
                                                        (ngModelChange)="handleOnInputValueChange($event,'phone',i)"
                                                        maxlength="11" autocomplete="no">
                                                    <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                        *ngIf="location.deliveryContact.phoneNumberErrorMsg"></span>
                                                    <label id="{{i}}" class="error help-block" for="{{i}}"
                                                        *ngIf="location.deliveryContact.phoneNumberErrorMsg">
                                                        {{location.deliveryContact.phoneNumberErrorMsg}}</label>
                                                                <!-- Please enter only Numbers -->
                                                    </div>
                                                    <div class="col-xs-6 no-right-pad inputParent">
                                                        <label class="prelabel preext left20">{{"startorderUk.reviewpage.ext" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                                        class="dynphnoextn form-control" id=""
                                                        [(ngModel)]="location.deliveryContact.ext" maxlength="4"  (keyup)="checkForErrrors()"
                                                        autocomplete="no" (ngModelChange)="handleOnInputValueChange($event,'ext',i)">
                                                        <span class="glyphicon form-control-feedback glyphicon-exclamation-sign" *ngIf="location.deliveryContact.phoneextErrorMsg"></span>
                                                        <label id="{{i}}" class="error help-block" for="{{i}}" *ngIf="location.deliveryContact.phoneextErrorMsg">
                                                            {{location.deliveryContact.phoneextErrorMsg}}</label>
                                                    </div>
                                                </div>
                                                <!-- <div class="userInfoHeader">NHS Code</div> -->
                                           <!--  <div class="inputParent col-xs-8 no-pad no-margin-bottom">
                                                <label class="prelabel">{{"startorderUk.reviewpage.nhscode" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                                class="form-control dynnhsreview" [(ngModel)]="location.nhsCode"
                                                (ngModelChange)="handleOnInputValueChange($event,'nhs',i)" maxlength="6"  (keyup)="checkForErrrors()"
                                                autocomplete="no" value="">
                                            <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                *ngIf="location.nhsErrorMsg"></span>
                                            <label id="{{i}}" class="error help-block" for="{{i}}"
                                                *ngIf="location.nhsErrorMsg">{{location.nhsErrorMsg}}</label>
                                            </div> -->
                                            </div>
                                        </div>
                                       <div class="no-padding" [ngClass]="seasonValue==prepreseason?'col-xs-4 ':'col-xs-12 prepredelivery horizontalview'">
                                        <div class="accountbox">
                                            <div class="userInfoHeader">Account Address</div>
                                           
                                                <div class="accounttext">{{reviewPageData?.orderSummary?.delLocation}}
                                                     </div>
                                                    
                                           
                                        </div>
                                        <div class="accountbox">
                                            
                                                
                                                    
                                                    <div [innerHtml]="reviewcontent?.LargeText2"></div>
                                                    <div class="rightText3 float_left" *ngIf="reviewPageData.reviewData.salesContact">
                                                        {{reviewPageData.reviewData.salesContact.name}}<br>{{reviewPageData.reviewData.salesContact.email}}<br>{{reviewPageData.reviewData.salesContact.phone}}
                                                        Ext. {{reviewPageData.reviewData.salesContact.ext}}</div>
                                              
                                                <div class="clearboth"></div>
                                             
                    
                                            
                                        </div>
                                        @if(seasonValue!=prepreseason){
                                            <div class="accountbox">
                                                
                                                
                                                    <div class=" float_left orderbox">
                                                        <div class="rightText4 no-margin">{{"startorderUk.reviewpage.orderterms" | cxTranslate}}</div>
                                        <div class="rightText5">{{"startorderUk.reviewpage.saleorreturn" | cxTranslate}}</div>
                                        <div class="rightText6">
                                            {{"startorderUk.reviewpage.sormessage1" | cxTranslate}}<span>
                                                @if(reviewPageData.priceResponse.SOR){{{reviewPageData.priceResponse.SOR
                                                    | number}}}
                                                @else{0}%</span>
                                                {{"startorderUk.reviewpage.sormessage2" | cxTranslate}}.</div>
                                        <div class="rightText7">Credit days</div>
                                        <div class="rightText8">
                                            {{"startorderUk.reviewpage.creditmessage1" | cxTranslate}}<span>
                                                {{reviewPageData.priceResponse.creditDays}}</span>
                                                {{"startorderUk.reviewpage.creditmessage2" | cxTranslate}}.</div>
                                                    </div>
                                                    <input type="hidden" id="business-org_type" value="GP Medical Practice">
                        
                                                
                        
                                            </div>
                                            }
                                       </div>
                        
                                    
                               
                              </div>
                              @if(seasonValue==prepreseason){
                              <div class="prepredelivery col-xs-12  preprebox" >
                                
                            <div class="col-xs-7 no-padding">
                                <div class="col-xs-12 no-padding licencetext margin-B20" [innerHtml]="reviewcontent?.LargeText1"></div>
                                <div class="inputParent col-xs-6 no-padding-right" [ngClass]="location.licenseInfo.nameErrorMsg ? 'has-error' : ''">
                                    <label class="prelabel left20">{{"startorderUk.reviewpage.licensename" | cxTranslate}}</label><input type="text" name="{{i}}"
                                    class="col-xs-6 form-control liname" id=""  (keyup)="checkForErrrors()"
                                    [(ngModel)]="location.licenseInfo.name"
                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoName',i)"
                                    autocomplete="no">
                                <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                    *ngIf="location.licenseInfo.nameErrorMsg"></span>
                                <label id="{{i}}" class="error help-block" for="{{i}}"
                                    *ngIf="location.licenseInfo.nameErrorMsg">
                                    {{location.licenseInfo.nameErrorMsg}}</label>                                        
                                            <!-- Please enter only letters -->
                                </div>
                                <div class="inputParent col-xs-6 positionrel " [ngClass]="location.licenseInfo.numberErrorMsg ? 'has-error' : ''">
                                    <label class="prelabel left20">{{"startorderUk.reviewpage.licensenum" | cxTranslate}}</label><input type="text" name="{{i}}"
                                    class="form-control lino" id="" [(ngModel)]="location.licenseInfo.number"
                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoNumber',i)"  (keyup)="checkForErrrors()"
                                    maxlength="15" autocomplete="no">
                                <span *ngIf="location.licenseInfo.numberErrorMsg"
                                    class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                    ></span>
                                <label id="{{i}}" class="error help-block" for="{{i}}"
                                    *ngIf="location.licenseInfo.numberErrorMsg">
                                    {{location.licenseInfo.numberErrorMsg}}</label>
                                </div>
                                <div class="licence_checkboxparent col-xs-12">
                                    <label class="checkbox-button inputParent" id="license_check"><input
                                        type="checkbox" name="checkbox[0]"
                                        [(ngModel)]="location.licenseInfo.checked" (change)="handlepreprebookvalidation($event)"
                                        (ngModelChange)="handleOnInputValueChange($event,'checkbox',i)"
                                        class="review_checkbox licenceCheckbox" id=""> <span
                                        class="checkbox-button_control"></span> <label class="checkboxtext">{{"ukmyorder.licconfmsg" | cxTranslate}}</label>
                                </label>
                                <label id="checkbox[1]-error" class="error help-block" for="checkbox[1]"
                                    *ngIf="location.licenseInfo.checkboxErrorMsg">{{location.licenseInfo.checkboxErrorMsg}}</label>
                                </div>
                            </div>
                            <div class="col-xs-5 no-padding">
                                <div class="userInfoHeader ">{{"startorderUk.reviewpage.ponumberfull" | cxTranslate}}</div>
                                <div class="userInfoDetails pomargin">Please enter your purchase order number, if required.</div>

                        <div class="inputParent col-xs-12 no-pad no-margin-bottom">
                            <label class="prelabel">{{"startorderUk.reviewpage.ponumber" | cxTranslate}}</label> <input type="text"
                            name="{{i}}" class="form-control" id="" value="" 
                            maxlength="10" autocomplete="no" [(ngModel)]="location.poNumber">
                        </div>
                            </div>
                              </div>}
                              @else{
                                <div class="prepredelivery col-xs-12  preprebox">

                                    <div class="col-xs-12 no-padding">
                                        <div class="col-xs-12 no-padding licencetext margin-B20"
                                            [innerHtml]="reviewcontent?.LargeText1"></div>
                                        <div class="inputParent col-xs-6 no-padding-right"
                                            [ngClass]="location.licenseInfo.nameErrorMsg ? 'has-error' : ''">
                                            <label class="prelabel left20">{{"startorderUk.reviewpage.licensename" |
                                                cxTranslate}}</label> <input type="text" name="{{i}}"
                                                class="col-xs-6 form-control liname" id=""
                                                (keyup)="checkForErrrors()" [(ngModel)]="location.licenseInfo.name"
                                                (ngModelChange)="handleOnInputValueChange($event,'licenseInfoName',i)"
                                                autocomplete="no">
                                            @if(location.licenseInfo.nameErrorMsg){
                                            <span
                                                class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                            }
                                            @if(location.licenseInfo.nameErrorMsg){
                                            <label id="{{i}}" class="error help-block" for="{{i}}">
                                                {{location.licenseInfo.nameErrorMsg}}</label>
                                            }
                                            <!-- Please enter only letters -->
                                        </div>
                                        <div class="inputParent col-xs-6 positionrel "
                                            [ngClass]="location.licenseInfo.numberErrorMsg ? 'has-error' : ''">
                                            <label class="prelabel left20">{{"startorderUk.reviewpage.licensenum" |
                                                cxTranslate}}</label><input type="text" name="{{i}}"
                                                class="form-control lino" id=""
                                                [(ngModel)]="location.licenseInfo.number"
                                                (keyup)="checkForErrrors()"
                                                (ngModelChange)="handleOnInputValueChange($event,'licenseInfoNumber',i)"
                                                maxlength="15" autocomplete="no">
                                            @if(location.licenseInfo.numberErrorMsg){
                                            <span
                                                class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                            }
                                            @if(location.licenseInfo.numberErrorMsg){
                                            <label id="{{i}}" class="error help-block" for="{{i}}">
                                                {{location.licenseInfo.numberErrorMsg}}</label>
                                            }
                                        </div>
                                        <div class="licence_checkboxparent col-xs-12">
                                            <label class="checkbox-button inputParent" id="license_check"> <input
                                                    type="checkbox" name="checkbox[0]"
                                                    (change)="handlepreprebookvalidation($event)"
                                                    [(ngModel)]="location.licenseInfo.checked"
                                                    (ngModelChange)="handleOnInputValueChange($event,'checkbox',i)"
                                                    class="review_checkbox licenceCheckbox" id=""> <span
                                                    class="checkbox-button_control"></span> <label
                                                    class="checkboxtext">{{"startorderUk.reviewpage.licenseconfirmmsg"
                                                    | cxTranslate}}</label>

                                            </label>
                                            @if(location.licenseInfo.checkboxErrorMsg){
                                            <label id="checkbox[1]-error" class="error help-block"
                                                for="checkbox[1]">{{location.licenseInfo.checkboxErrorMsg}}</label>
                                            }
                                        </div>
                                    </div>
                                   
                                </div>
                                <div class="prepredelivery col-xs-12  preprebox">
                                    <div class="col-xs-12 no-padding">
                                        <div class="userInfoHeader ">
                                            {{"startorderUk.reviewpage.ponumberfull" | cxTranslate}}</div>
                                            <div class="userInfoDetails margin-B20">Please enter your purchase order number, if required.</div>
                                        <div class="inputParent col-xs-12 no-pad no-margin-bottom">
                                            <label class="prelabel">{{"startorderUk.reviewpage.ponumber" |
                                                cxTranslate}}</label> <input type="text" name="{{i}}"
                                                class="form-control" id="" value="" maxlength="10" autocomplete="no"
                                                [(ngModel)]="location.poNumber">
                                        </div>
                                    </div>
                                </div>
                              }
                                    <form #weekselectionform="ngForm">

                                        <div class="deliveylocation col-xs-12 no-padding">
                                            <div class="greyline"></div>
                                           <!--  <div class="row">
                                                <div class="col-xs-1 locationNumber" *ngIf="seasonValue!=prepreseason">{{reviewPageData?.orderSummary?.delLocation}}
                                                </div>
                                            </div> -->
                                            <div  [ngClass]="seasonValue==prepreseason?'prepreboxdelivery':'border_box'">
                                                <div class="row">
                                                    <div class="prodTableHeader"><span *ngIf="seasonValue!=prepreseason">Amended </span>Products</div><!-- HARDCORED -->

                                                </div>
                                                <div class="row margin-B20">
                                                    <div class="seasonvalue no-padding">{{reviewdelivery}} Delivery Dates</div>
                                                    <div class="no-padding deliveyweek">(week commencing)</div><!-- HARDCORED -->

                                                </div>
                                                <div class="row">
                                                    <div class="col-xs-12 no-padding">

                                                        <table class="deliverytable">
                                                            <ng-container
                                                            *ngFor=" let prodData of location.products; let p= index">
                                                                    <ng-container
                                                                        *ngIf="(prodData.baseName=='AQIV' || prodData.baseName=='Aujemflu') && prodData.qty !== 0">

                                                                        <tr>
                                                                            @if(reviewPageData.productList[0].baseProductName=='aTIV - 10 Pack'){
                                                                                <td class="productheader" colspan="13">
                                                                                  
                                                                                    {{"startorderUk.deliveryweek.ativ" | cxTranslate}}
                                                                                  
                                                                                    <span> (aIIV)</span>
                                                                                    <div class="middletext"><span
                                                                                        class="tenpack">{{"startorderUk.deliveryweek.10packlabel"
                                                                                        | cxTranslate}}</span>
                                                                                    <br><span class="prepreyear">(50+ years)</span></div>
                                                                                    
                                                                                </td>
                                                                                }
                                                                                @else{
                                                                                    <td class="productheader" colspan="13">
                                                                                    Aujemflu (aIIVc) <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                                        | cxTranslate}}</span>
                                                                                        <div class="middletext middletextnew"><div class="listprice">{{reviewcontent?.solutiontype}}</div>
                                                                                       
                                                                                        <div class="priceDetail">Customer Price &#163;<span>{{reviewPageData?.productList[0]?.priceData?.value
                                                                                            | number:'1.2' }}</span>  (ex VAT)</div></div>
                                                                                    </td>
                                                                                }
                                                                       
                                                                        </tr>
                                                            <tr id="month">
                                                                
                                                                <ng-container
                                                                    *ngFor="let deliverydate of deliverySlotArray;let d=index">
                                                                    <ng-container *ngIf="d!= maxDeliverySlots">
                                                                        <td class=" datetext">{{deliverydate.month}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container *ngIf="d == maxDeliverySlots">
                                                                        <td class="gapbet"></td>
                                                                        <td class=" datetext">{{deliverydate.month}}
                                                                        </td>
                                                                    </ng-container>

                                                                </ng-container>

                                                                <td class="gapdose"></td>
                                                                <td class=" dosestext">Doses</td>
                                                               

                                                            </tr>
                                                            <tr class="">
                                                                
                                                                <ng-container
                                                                    *ngFor="let deliverydate of deliverySlotArray;let d=index">
                                                                    <ng-container
                                                                        *ngIf="d!=maxDeliverySlots;else gap">
                                                                        <td class=" datetext">{{deliverydate.date}}</td>
                                                                    </ng-container>
                                                                    <ng-template #gap>
                                                                        <td class="gapbet"></td>
                                                                        <td class=" datetext">{{deliverydate.date}}</td>
                                                                    </ng-template>

                                                                </ng-container>


                                                                <td class="gapdose"></td>
                                                                <td class=" dosestext">Ordered</td>
                                                                

                                                            </tr>
                                                           
                                                                        <tr id="delivey_aQIV">

                                                                           


                                                                            

                                                                            <ng-container
                                                                                *ngFor="let productinput1 of prodData.deliverySlots;let j=index">
                                                                                <ng-container
                                                                                    *ngIf="j!=maxDeliverySlots;else product1gap">
                                                                                    <td class="deliverydate_input">
                                                                                        <input type="text"
                                                                                        value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                           
                                                                                            autocomplete="off" readonly
                                                                                            class="delivery_data  aqivcount form-control dynvacinedoses"
                                                                                            id="aqivfirst[{{i}}][{{j}}]"
                                                                                            name="createOrderData[{{i}}].createOrderProductData[0].createOrderDeliverySlotData[{{j}}]].quantity" />
                                                                                    </td>
                                                                                </ng-container>
                                                                                <ng-template #product1gap>
                                                                                    <td class="gapbet"></td>
                                                                                    <td class="deliverydate_input">
                                                                                        <input type="text"
                                                                                            autocomplete="off" readonly
                                                                                            value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                           
                                                                                            class="delivery_data  aqivcount form-control dynvacinedoses"
                                                                                            id="aqivfirst[{{i}}][{{j}}]"
                                                                                            name="createOrderData[{{i}}].createOrderProductData[0].createOrderDeliverySlotData[{{j}}]].quantity" />
                                                                                    </td>
                                                                                </ng-template>

                                                                            </ng-container>

                                                                            <td class="gapdose"></td>
                                                                             <td
                                                                                class="deliveryallocated_input dosesbox">
                                                                                <input type="text" autocomplete="off"
                                                                                    class=" delivery_data aqiv_allocated form-control dynallacted"
                                                                                    id="aqivallocated[{{i}}]" 
                                                                                    name="deliveryweek.aqivallocated[{{i}}]"
                                                                                    readonly value="{{prodData.qty | number}}" />
                                                                                    
<!--                                                                                     <div class="totalcost" *ngIf="seasonValue!=prepreseason">{{"ukmyorder.totaltxt" | cxTranslate}}&#163;{{prodData.qty * reviewPageData?.productList[0]?.priceData?.value | number:'1.2'}}</div>
 -->                                                                            </td>
                                                                            <!--<td class="greentick">
                                                                            </td> -->
                                                                        </tr>

                                                                        <tr>
                                                                            <td></td>
                                                                            
                                                                            <td colspan="13" class="rightfloat"> @if(seasonValue!=prepreseason){
                                                                                <div class="totaldose">
                                                                                    Total (ex VAT)
                                                                                </div>}</td>
                                                                            <td >
            
            
                                                                                @if(seasonValue!=prepreseason){
                                                                                    <input autocomplete="off"
                                                                                    class=" delivery_data aqivtotal form-control " name="deliveryweek.aqivtotalcost"
                                                                                    id="aqivtotalcost" [value]="prodData.qty *
                                                                                        reviewPageData?.productList[0]?.priceData?.value | currency:'GBP':'symbol':'1.2-2'
                                                                                        " 
                                                                                    readonly />
                                                                                   
                                                                                        }
            
                                                                            </td>
                                                                        </tr>

                                                                    </ng-container>
                                                                <ng-container *ngIf="prodData.baseName=='QIVC' && prodData.qty !== 0">

                                                                    <tr>
                                                                        @if(reviewPageData.productList[1].baseProductName=='TIVc - 10 Pack'){
                                                                            <td class="productheader" colspan="13">
                                                                                {{"startorderUk.deliveryweek.tivc" | cxTranslate}}
                                                                                <span> (IIVc)</span>@if(seasonValue==prepreseason){
                                                                                    <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                                        | cxTranslate}}</span>
                                                                                        <div class="middletext">
                                                                                            <span class="tenpack float_left">
                                                                                                <span
                                                                                                    class="float_left">{{"startorderUk.deliveryweek.10packlabel"
                                                                                                    | cxTranslate}} </span>
                                                                                                <br>
                                                                                                <span
                                                                                                    class="prepreyear">{{"startorderUk.deliveryweek.18to64yearslabel"
                                                                                                    | cxTranslate}}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                }@else{
                                                                                    <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                                        | cxTranslate}}</span>
                                                                                    <div class="middletext  middletextnew"><div class="listprice">{{reviewcontent?.headline}}</div>        
                                                                                       
                                                                                    <div class="priceDetail">Customer Price &#163;<span>{{reviewPageData?.productList[1]?.priceData?.value
                                                                                        | number:'1.2' }}</span>  (ex VAT)</div></div>
                                                                                }
                                                                               
                                                                            </td>
                                       
                                                                                }
                                                                             
                                                                                
                    
                    
                                                                               
                    
                    
                    
                    
                    
                                                                    </tr> 

                                                                    <tr id="month">
                                                                
                                                                        <ng-container
                                                                            *ngFor="let deliverydate of deliverySlotArray;let d=index">
                                                                            <ng-container *ngIf="d!= maxDeliverySlots">
                                                                                <td class=" datetext">{{deliverydate.month}}
                                                                                </td>
                                                                            </ng-container>
                                                                            <ng-container *ngIf="d == maxDeliverySlots">
                                                                                <td class="gapbet"></td>
                                                                                <td class=" datetext">{{deliverydate.month}}
                                                                                </td>
                                                                            </ng-container>
        
                                                                        </ng-container>
        
                                                                        <td class="gapdose"></td>
                                                                        <td class=" dosestext">Doses</td>
                                                                        
        
                                                                    </tr>
                                                                    <tr class="">
                                                                        
                                                                        <ng-container
                                                                            *ngFor="let deliverydate of deliverySlotArray;let d=index">
                                                                            <ng-container
                                                                                *ngIf="d!=maxDeliverySlots;else gap">
                                                                                <td class=" datetext">{{deliverydate.date}}</td>
                                                                            </ng-container>
                                                                            <ng-template #gap>
                                                                                <td class="gapbet"></td>
                                                                                <td class=" datetext">{{deliverydate.date}}</td>
                                                                            </ng-template>
        
                                                                        </ng-container>
        
        
                                                                        <td class="gapdose"></td>
                                                                        <td class=" dosestext">Ordered</td>
                                                                      
        
                                                                    </tr>
                                                                    <tr id="delivey_QIVc">
                        
                                                                      
                                                                        <ng-container
                                                                            *ngFor="let productinput2 of prodData.deliverySlots;let j=index">
                                                                            <ng-container
                                                                                *ngIf="j!=maxDeliverySlots;else product2gap">
                                                                                <td class="deliverydate_input">
                                                                                    <input type="text"
                                                                                        autocomplete="off" readonly
                                                                                        value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                       
                                                                                        class="delivery_data qivccount  form-control dynvacinedoses"
                                                                                        id="qivcfirst[{{i}}][{{j}}]"
                                                                                        name="createOrderData[{{i}}].createOrderProductData[1].createOrderDeliverySlotData[{{j}}].quantity"
                                                                                        />
                                                                                </td>
                                                                            </ng-container>
                                                                            <ng-template #product2gap>
                                                                                <td class="gapbet"></td>
                                                                                <td class="deliverydate_input">
                                                                                    <input type="text"
                                                                                        autocomplete="off" readonly
                                                                                        value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                       
                                                                                        class="delivery_data qivccount form-control dynvacinedoses"
                                                                                        id="qivcfirst[{{i}}][{{j}}]"
                                                                                        name="createOrderData[{{i}}].createOrderProductData[1].createOrderDeliverySlotData[{{j}}].quantity"
                                                                                        />
                                                                                </td>
                                                                            </ng-template>
                        
                                                                        </ng-container>
                        
                                                                        <td class="gapdose"></td>
                                                                         <td class="deliveryallocated_input dosesbox"><input
                                                                                type="text" autocomplete="off" readonly
                                                                                class="  delivery_data qivcallocated form-control dynallacted"
                                                                                id="qivcallocated[{{i}}]"  value="{{prodData.qty | number}}"
                                                                                name="deliveryweek.qivcallocated[{{i}}]"  />
                                                                                
<!--                                                                                 <div class="totalcost" *ngIf="seasonValue!=prepreseason">{{"ukmyorder.totaltxt" | cxTranslate}}&#163;{{prodData.qty * reviewPageData?.productList[1]?.priceData?.value | number:'1.2'}}</div>
 -->                                                                        </td>
                                                                        <!--<td class="deliverydate_input dosesbox "><input type="number" 
                                                                                autocomplete="off" class=" delivery_data qivctotal form-control"
                                                                                id="qivctotal[{{i}}]" value={{product.deliverySlots[j].quantity}} readonly /></td>
                                                                        <td class="greentick" >
                                                                        </td> -->
                                                                    </tr>
                                                                    <tr class="qivcyear">
                                                               
                                                                        <td  >
                                                                        </td>
                                                                         <td colspan="13" class="rightfloat">
        
        
                                                                            @if(seasonValue!=prepreseason){
                                                                                <div class="totaldose">
                                                                                    Total (ex VAT)
                                                                                </div>
                                                                            }
                                                                                </td>
                                                                                <td>
                                                                                    @if(seasonValue!=prepreseason){
                                                                                <input autocomplete="off"
                                                                                class=" delivery_data aqivtotal form-control " name="deliveryweek.aqivtotalcost"
                                                                                id="aqivtotalcost" [value]="prodData.qty *
                                                                                    reviewPageData?.productList[1]?.priceData?.value | currency:'GBP':'symbol':'1.2-2'
                                                                                    " 
                                                                                readonly />
                                                                               
                                                                                    }
        
                                                                        </td>
                                                                    </tr>
                                                                   
                        
                                                                </ng-container>
                                                                </ng-container>
                                                                @if(seasonValue!=prepreseason){
                                                                <tr class="margin-T20">

                                                                    <td ></td>
                                                                    <td colspan="13" class="rightfloat totaldose">Total Cost (ex VAT)</td>
                                                                   
                                                                    <td class=""> 
                                                                        <input autocomplete="off"
                                                                        class=" delivery_data aqivtotal form-control totalreviewcost" name="deliveryweek.aqivtotalcost"
                                                                        id="aqivtotalcost" [value]="'£' + (location.prodCost)"
                                                                        readonly />
                                                                        
                                                                    
                                                                </td>
                                                                    
                                                                </tr>
                                                            }
                                                            @else{
                                                                <tr>
                                                                    <td colspan="18"  class="pricetext">{{reviewcontent?.largeparagraphcontent}}</td>
                                                                    </tr>
                                                                }




                                                        </table>




                                                    </div>


                                                </div>
                                            </div>
                                        </div>


                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- User info starts -->

                  <!--   <div class="userInfoContainer" *ngIf="seasonValue!=prepreseason">
                        <div class="col-xs-4 no-pad col1 salebox">
                            <div class="border_box float_left">
                                <div [innerHtml]="reviewcontent?.LargeText2"></div>
                                <div class="rightText3 float_left" *ngIf="reviewPageData.reviewData.salesContact">
                                    {{reviewPageData.reviewData.salesContact.name}}<br>{{reviewPageData.reviewData.salesContact.email}}<br>{{reviewPageData.reviewData.salesContact.phone}}
                                    {{"ukmyorder.ext" | cxTranslate}} {{reviewPageData.reviewData.salesContact.ext}}</div>
                            </div>
                            <div class="clearboth"></div>

                            <div class="border_box float_left orderbox">
                        
                

                    <div class="rightText4">{{"ukmyorder.orderterms" | cxTranslate}}</div>
                    <div class="rightText5">{{"ukmyorder.sortxt" | cxTranslate}}</div>
                    <div class="rightText6">
                        {{"ukmyorder.sormsg1" | cxTranslate}}<span>
                            {{reviewPageData.priceResponse.SOR | number}}%</span>
                            {{"ukmyorder.sormsg2" | cxTranslate}}</div>
                    <div class="rightText7">{{"ukmyorder.creditdayslabel" | cxTranslate}}</div>
                    <div class="rightText8">
                        {{"ukmyorder.invoicetxt" | cxTranslate}}<span>
                            {{reviewPageData.priceResponse.creditDays}}</span>
                            {{"ukmyorder.creditdaytxt" | cxTranslate}}</div>

                            </div>
                          
                            <input type="hidden" id="business-org_type" value="GP Medical Practice">

                        </div>

                        <div class="col-xs-8 box_2colparent no-pad">
                            <div class="col-xs-6 border_box col2">
                                <div [innerHtml]="reviewcontent?.content"></div>
                                <div class="col-xs-12 inputSection">
                                    <div class="inputParent col-xs-8 no-pad">
                                        <label>{{"ukmyorder.fname" | cxTranslate}}</label> <input type="text"
                                            [ngClass]="location.deliveryContact.firstNameErrorMsg ? 'has-error' : ''"
                                            name="{{i}}" class="dynFirstname col-xs-6 form-control" id=""
                                            [(ngModel)]="location.deliveryContact.name"
                                            (ngModelChange)="handleOnInputValueChange($event,'firstName',i)"
                                            autocomplete="no">
                                        <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                            *ngIf="location.deliveryContact.firstNameErrorMsg"></span>
                                        <label id="{{i}}" class="error help-block" for="{{i}}"
                                            *ngIf="location.deliveryContact.firstNameErrorMsg ">{{location.deliveryContact.firstNameErrorMsg}}</label>
                                        
                                    </div>
                                    <div class="inputParent positionrel"
                                        [ngClass]="location.deliveryContact.emailErrorMsg ? 'has-error' : ''">
                                        <label>{{"ukmyorder.email" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                            [(ngModel)]="location.deliveryContact.email"
                                            (ngModelChange)="handleOnInputValueChange($event,'email',i)"
                                            class="dynemail form-control" id="" autocomplete="no">
                                        <span *ngIf="location.deliveryContact.emailErrorMsg"
                                            class="glyphicon form-control-feedback glyphicon-exclamation-sign" ></span>
                                        <label id="{{i}}" class="error help-block" for="{{i}}"
                                            *ngIf="location.deliveryContact.emailErrorMsg">{{location.deliveryContact.emailErrorMsg}}</label>
                                    </div>
                                    <div class="">
                                        <div class="col-xs-8 no-pad inputParent"
                                            [ngClass]="location.deliveryContact.phoneNumberErrorMsg ? 'has-error' : ''">
                                            <label>{{"ukmyorder.phnum" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                                class="dynphno form-control" id=""
                                                [(ngModel)]="location.deliveryContact.phone"
                                                (ngModelChange)="handleOnInputValueChange($event,'phone',i)"
                                                maxlength="11" autocomplete="no">
                                            <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                *ngIf="location.deliveryContact.phoneNumberErrorMsg"></span>
                                            <label id="{{i}}" class="error help-block" for="{{i}}"
                                                *ngIf="location.deliveryContact.phoneNumberErrorMsg">
                                                {{location.deliveryContact.phoneNumberErrorMsg}}</label>
                                          
                                        </div>
                                        <div class="col-xs-4 no-right-pad inputParent">
                                            <label>{{"ukmyorder.ext" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                                class="dynphnoextn form-control" id=""
                                                [(ngModel)]="location.deliveryContact.ext" maxlength="4"
                                                autocomplete="no" (ngModelChange)="handleOnInputValueChange($event,'ext',i)">
                                                <span class="glyphicon form-control-feedback glyphicon-exclamation-sign" *ngIf="location.deliveryContact.phoneextErrorMsg"></span>
                                                <label id="{{i}}" class="error help-block" for="{{i}}" *ngIf="location.deliveryContact.phoneextErrorMsg">
                                                    {{location.deliveryContact.phoneextErrorMsg}}</label>
                                        </div>
                                    </div>
                                 
                                <div class="inputParent col-xs-8 no-pad">
                                    <label>{{"ukmyorder.nhscode" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                        class="form-control dynnhsreview" [(ngModel)]="location.nhsCode"
                                        (ngModelChange)="handleOnInputValueChange($event,'nhs',i)" maxlength="6"
                                        autocomplete="no" value="">
                                    <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                        *ngIf="location.nhsErrorMsg"></span>
                                    <label id="{{i}}" class="error help-block" for="{{i}}"
                                        *ngIf="location.nhsErrorMsg">{{location.nhsErrorMsg}}</label>
                                </div>
                                </div>
                            </div>
                            <div class="col-xs-6 no-padding-left">
                                <div class="border_box">
                                    <div class="userInfoHeader">{{"ukmyorder.pofulltxt" | cxTranslate}}</div>
                                    <div class="inputParent col-xs-8 no-pad no-margin-bottom">
                                        <label>{{"ukmyorder.polabel" | cxTranslate}}</label> <input type="text"
                                            name="{{i}}" class="form-control" id="" value="" 
                                            maxlength="10" autocomplete="no" [(ngModel)]="location.poNumber">
                                    </div>
                                    <div class="clearboth"></div>
                                </div>
                                <div class="border_box float_left">
                                    <div [innerHtml]="reviewcontent?.LargeText1"></div>
                                <div class="col-xs-12 inputSection">
                                    <div class="inputParent col-xs-9 no-pad"
                                        [ngClass]="location.licenseInfo.nameErrorMsg ? 'has-error' : ''">
                                        <label>{{"ukmyorder.licname" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                            class="col-xs-6 form-control liname" id=""
                                            [(ngModel)]="location.licenseInfo.name"
                                            (ngModelChange)="handleOnInputValueChange($event,'licenseInfoName',i)"
                                            autocomplete="no">
                                        <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                            *ngIf="location.licenseInfo.nameErrorMsg"></span>
                                        <label id="{{i}}" class="error help-block" for="{{i}}"
                                            *ngIf="location.licenseInfo.nameErrorMsg">
                                            {{location.licenseInfo.nameErrorMsg}}</label>
                                   
                                    </div>
                                    <div class="inputParent positionrel"
                                        [ngClass]="location.licenseInfo.numberErrorMsg ? 'has-error' : ''">
                                        <label>{{"ukmyorder.licnum" | cxTranslate}}</label> <input type="text" name="{{i}}"
                                            class="form-control lino" id="" [(ngModel)]="location.licenseInfo.number"
                                            (ngModelChange)="handleOnInputValueChange($event,'licenseInfoNumber',i)"
                                            maxlength="15" autocomplete="no">
                                        <span *ngIf="location.licenseInfo.numberErrorMsg"
                                            class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                            ></span>
                                        <label id="{{i}}" class="error help-block" for="{{i}}"
                                            *ngIf="location.licenseInfo.numberErrorMsg">
                                            {{location.licenseInfo.numberErrorMsg}}</label>
                                    </div>
                                    <div class="licence_checkboxparent">
                                        <label class="checkbox-button inputParent" id="license_check"> <input
                                                type="checkbox" name="checkbox[0]"
                                                [(ngModel)]="location.licenseInfo.checked"
                                                (ngModelChange)="handleOnInputValueChange($event,'checkbox',i)"
                                                class="review_checkbox licenceCheckbox" id=""> <span
                                                class="checkbox-button_control"></span> <label class="checkboxtext">{{"ukmyorder.licconfmsg" | cxTranslate}}</label>
                                        </label>
                                        <label id="checkbox[1]-error" class="error help-block" for="checkbox[1]"
                                            *ngIf="location.licenseInfo.checkboxErrorMsg">{{location.licenseInfo.checkboxErrorMsg}}</label>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <input type="hidden" name="createOrderData[1].sorNumber" value="">
                <input type="hidden" name="createOrderData[1].creditDays" value="120">
                <input type="hidden" name="createOrderData[1].locID" value="60149134">
            </div>
            <div>
                <input type="hidden" name="CSRFToken" value="e21a9d3d-fa32-4dd8-bd3a-3b3731da1b6c">
            </div>
        </div>
        <div class="clearboth"></div>
<!--         <div class=" col-md-12 finaltotal " *ngIf="seasonValue!=prepreseason">{{"ukmyorder.grandtotal" | cxTranslate}} £{{totalCost}}</div>
 -->        <!-- confirm order section starts -->
        <div class="bottomBG" *ngIf="seasonValue!=prepreseason">
            <div class="col-xs-12 OM_tableBottomBtn" >
                <div class="col-xs-12 col-md-12">
                    <div class="bootom_headerText">Confirm your order to secure your delivery slot for the&nbsp;<span
                            class="reviewseasontxt">{{seasonValue | seasonspilt}}</span>&nbsp;season</div>
                    <div class="main_checkboxparent col-md-12">
                        <label class="checkbox-button"> <input type="checkbox" name="" [checked]="checkbox"
                                (click)="handleOnCommonCheckboxvalueChange($event)" class="review_checkbox mainCheck"
                                id="">
                            <span class="checkbox-button_control"></span>
                        </label> <label class="mainCheckText">{{"ukmyorder.confirmmsg1" | cxTranslate}}<a
                                href="/termsOfSale" target="_blank" class="showPopupclick"><b>{{"ukmyorder.termsnsale" | cxTranslate}}</b></a>,
                                {{"ukmyorder.confirmmsg2" | cxTranslate}}{{reviewdelivery}}&nbsp;{{"ukmyorder.confirmmsg3" | cxTranslate}}</label>
                    </div>
                </div>
                
            </div>
            <!-- register checkbox -->
            <div class="col-xs-12 col-md-12 materialcheckbox">
               
                <div class="main_checkboxparent col-md-12 materialcheckparent">
                    <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="materialcheck"
                        class="review_checkbox mainCheck materialcheck" id="">
                        <span class="checkbox-button_control"></span>
                    </label> <label class="mainCheckText">{{"ukmyorder.promotionmsg" | cxTranslate}}
                    </label>
                </div>
            </div>
            <div class="col-xs-12 col-md-4 OM_confirmBtnParent">
                <button class="OM_confirmOrderBtn prvntDoubleClick" [disabled]="!checkbox"
                    (click)="handleOnOrderClick('confirmOrder')">{{"ukmyorder.confirmorderlabel" | cxTranslate}}</button>
            </div>
            <div class="clearboth"></div>
            <div class="col-xs-12 astericText">
                <div class="astericTextpara1">{{"ukmyorder.riskfreetxt" | cxTranslate}}</div>
                <div class="astericTextpara2">{{reviewcontent?.paragraphcontent}}</div>
            </div>
            <!-- save order section -->
            <!-- <div class="saveParent" *ngIf="seasonValue == '2025-2026'">
                <div class="saveOrderSection">
                    <div class="col-xs-12 col-md-10 saveText">If you're not ready to confirm, you can save this order.
                        This will remain in a pending status until confirmed. Whilst pending, your volume, terms and
                        delivery schedule are not guaranteed and may be lost.</div>
                    <button class="OM_saveOrderBtn prvntDoubleClick" [disabled]="!enableSaveOrder"
                        (click)="handleOnOrderClick('save')">Save Order</button>
                </div>
            </div> -->
        </div>
        <div *ngIf="seasonValue==prepreseason" class="col-xs-12">
            <div  class="confirmbox col-xs-12">
               <div  class="confirmtext">Confirming the pre-order delivery slot for the {{prepreseason | seasonspilt}} flu season</div>
               
             
               <div class="col-xs-12 col-md-12 prepreseaoncheck">
                   <div class="main_checkboxparent col-md-11 no-padding">
                       <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="materialcheck"
                           class="review_checkbox mainCheck materialcheck" id="">
                           <span class="checkbox-button_control"></span>
                       </label> <label class="mainCheckText">{{reviewcontent?.LargeText4}}
                       </label>
                   </div>
                   
                   
               </div>
               <button class="prepreconfimrbtn" [disabled]="!isAllFieldsValid" (click)="handleOnOrderClick('confirmOrder')">Confirm Order</button>
               <div class="col-xs-12 astericText" [innerHtml]="reviewcontent?.LargeText3"></div>
           
   
            </div>
           </div>

        <!-- provisional order -->
        <div class="clearboth"></div>
        <!-- <div class="provisionalbottomBG">
            <div class="col-xs-12 OM_tableBottomBtn protablebottom">
                <div class="col-xs-12 col-md-8">
                    <div class="bootom_headerText no-margin-bottom">Save your <span
                            class="reviewseasontxt">2024/25</span> provisional order</div>
                    <div class="col-md-10 no-padding margin-T10 ProvisionalReviewSubtext">
                        Once the&nbsp;2024/25&nbsp;flu season ordering opens in August 2024, a final order will be
                        emailed to you outlining full commercial terms</div>
                </div>
                <div class="col-xs-12 col-md-4 saveOrderSection provisionalsection">
                    <button class="OM_saveOrderBtn provisionalsave prvntDoubleClick" disabled="">Save Provisional
                        Order</button>
                </div>
            </div>

        </div> -->

        <!-- In Season Order Changes -->
        <!-- <div class="InseasonbottomBG" style="display: block;">
            <div class="col-xs-12 OM_tableBottomBtn protablebottom">
                <div class="col-xs-12 col-md-8">
                    <div class="bootom_headerText">Confirm your order to secure your&nbsp;<span
                            class="reviewseasontxt">2024/25</span>&nbsp;season order</div>
                    <div class="main_checkboxparent col-md-10">
                        <label class="checkbox-button"> <input type="checkbox" name="" value=""
                                class="review_checkbox mainCheck" id="">
                            <span class="checkbox-button_control"></span>
                        </label> <label class="mainCheckText">By confirming my order I agree to the <a
                                href="/termsOfSale" target="_blank" class="showPopupclick">Terms of Sale</a> including
                                {{reviewPageData.priceResponse.SOR}} SOR </label>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4 inseasonsection pr-0">
                    <button class="inseasonbtn prvntDoubleClick" disabled="">Confirm Order</button>
                </div>
            </div>
        </div> -->
        <!--  Closed -->

    </section>
</div>
</div>
}
